export default __webpack_public_path__ + "static/media/radiuschat-omni.70d72378.png";